<template>
    <Modal v-model="modal"
           :title="`${$t('配置接收人')}`"
           :mask-closable="false"
           :loading="loading"
           @on-ok="submit"
           @on-cancel="modal = false"
           width="900">
        <div v-if="msgConfigs.length===1"
             class="title-level">
            {{$t('消息类型')}} : {{msgConfigs[0].msgTypeName}} - {{msgConfigs[0].msgName}}
        </div>
        <div v-else
             class="tips">
            <i class="icon-prompt-1-o"></i>
            <div class="tips-content">
                {{$t('批量添加接收人会统一覆盖原有配置，请注意修改。默认接收人不受影响。')}}
            </div>
        </div>
        <loading v-if="contentLoading"
                 style="min-height: 80px"></loading>
        <Form v-show="!contentLoading"
              ref="form"
              :model="formData"
              @submit.native.prevent>
            <table class="custom-table-panel"
                   cellpadding="0"
                   cellspacing="0">
                <tr>
                    <th width="180"
                        class="require">{{$t('接收人姓名')}}</th>
                    <th width="220"
                        class="require">{{$t('邮箱')}}</th>
                    <th width="180"
                        class="require">{{$t('电话')}}</th>
                    <th>{{$t('备注')}}</th>
                    <th>{{$t('操作')}}</th>
                </tr>
                <tbody>
                    <tr v-for="(contact, i) in formData.insert"
                        :key="i">
                        <td>
                            <template v-if="contact.id">{{contact.name}}</template>
                            <FormItem v-else
                                      :prop="`insert[${i}].name`"
                                      :rules="formRule.name">
                                <Select v-model="contact.name"
                                        clearable
                                        filterable
                                        @on-change="accountChange($event, i)">
                                    <!-- :allow-create="true" -->
                                    <Option v-for="account in accountNames"
                                            :key="account"
                                            :value="account">{{account}}</Option>
                                </Select>
                            </FormItem>
                        </td>
                        <td>
                            <FormItem :prop="`insert[${i}].email`"
                                      :rules="formRule.email">
                                <div class="td-panel">
                                    <Input v-model="contact.email"
                                           type="text"
                                           :placeholder="$t('请输入')" />
                                    <div style="width: 20px">
                                        <Tooltip v-if="contact.email && contact.oldEmail === contact.email && contact.emailValidate !== 1"
                                                 translate
                                                 placement="top-end">
                                            <i class="icon-prompt-1-o"
                                               style="margin-left: 5px;"></i>
                                            <div slot="content">
                                                {{$t('邮箱未验证，不能接收消息')}}
                                                <a v-show="!contact.countDown.email.showCount && hasPermission('CF0904')"
                                                   @click="validateContactInformation( 'email', i)"
                                                   style="margin-left: 5px;">{{$t('发送验证')}}</a>
                                                <span v-show="contact.countDown.email.showCount">({{contact.countDown.email.count}})</span>
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                            </FormItem>
                        </td>
                        <td>
                            <FormItem :prop="`insert[${i}].phone`"
                                      :rules="formRule.phone">
                                <div class="td-panel">
                                    <Input v-model="contact.phone"
                                           type="text"
                                           :placeholder="$t('请输入')" />
                                    <div style="width: 20px">
                                        <Tooltip v-if="contact.phone && contact.oldPhone === contact.phone && contact.phoneValidate !== 1"
                                                 translate
                                                 placement="top-end">
                                            <i class="icon-prompt-1-o"
                                               style="margin-left: 5px;"></i>
                                            <div slot="content">
                                                {{$t('手机未验证，不能接收消息')}}
                                                <a v-show="!contact.countDown.phone.showCount && hasPermission('CF0904')"
                                                   @click="validateContactInformation('phone', i)"
                                                   style="margin-left: 5px;">{{$t('发送验证')}}</a>
                                                <span v-show="contact.countDown.phone.showCount">({{contact.countDown.phone.count}})</span>
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                            </FormItem>
                        </td>
                        <td>
                            <FormItem>
                                <Input v-model="contact.description"
                                       type="text"
                                       :placeholder="$t('请输入')" />
                            </FormItem>
                        </td>
                        <td>
                            <div class="td-txt"
                                 style="padding: 0 5px;">
                                <a :class="contact.defaultContact && 'a-disabled'"
                                   @click="!contact.defaultContact && deletee(i)">
                                    <i class="icon-delete-o"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="9">
                            <a @click="add()">
                                <i class="icon-plus-o-1"
                                   style="vertical-align: middle; margin: 0 3px 0 10px;"></i>{{$t('添加接收人')}}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Form>
    </Modal>
</template>

<script>
import loading from '@c/basic/loading'

import { isPhone } from '@/service/validator'
import API from '@/service/api.js'
export default {
    name: 'setaddressee',
    components: {
        loading
    },
    props: {
        type: {
            type: String,
            default: 'create' // create, edit , detail
        },
        defaultData: {
        }
    },
    data () {
        const countDownJSON = JSON.stringify({
            email: {
                showCount: false,
                count: 60
            },
            phone: {
                showCount: false,
                count: 60
            }
        })
        return {
            modal: false,
            loading: true,
            contentLoading: false,
            countDownJSON,
            formData: {
                insert: [],
                template: {
                    name: '',
                    email: '',
                    phone: '',
                    emailValidate: 0,
                    phoneValidate: 0,
                    description: '',
                    defaultContact: 0,
                    countDown: JSON.parse(countDownJSON)
                }
            },
            msgConfigs: [],
            formRule: {
                name: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            // const ruleIndex = (rule.match(/(?<=\[)(.+?)(?=\])/g) || [])[0]
                            // const sameIndex = []
                            // for (let i = 0; i < this.formData.insert; i++) {
                            //     if (this.formData.insert[i].name === value && i.toString() === ruleIndex) {
                            //         sameIndex.push(i)
                            //     }
                            // }
                            const currentUserSid = (this.accountInfObj[value] || {}).userSid
                            if (this.formData.insert.filter(item => `${item.userSid}` === `${currentUserSid}`).length > 1) {
                                callback(new Error(this.$t('接收人不能重复')))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }

                ],
                email: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { type: 'email', message: this.$i18n.t('邮箱格式错误'), trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value.substr(0, 4) === 'test') {
                                callback(new Error(this.$i18n.t('不能以test开头')))
                            } else if (value.substr(0, 5) === 'admin') {
                                callback(new Error(this.$i18n.t('不能以admin开头')))
                            } else if (value.split('@')[0].length < 2 || value.split('@')[0].length > 16) {
                                callback(new Error(this.$i18n.t('邮箱前缀2-16个字符')))
                            } else if (/^[`~!@#$^&*=|{}':;,.<>/?~！@#￥……&*——|【】‘；：”“'。，、？%+ "\\\\]+$/.test(value.split('@')[0])) {
                                callback(new Error(this.$i18n.t('不能使用全部是特殊符号')))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                phone: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            !value ? callback() : isPhone(rule, value, callback)
                        },
                        trigger: 'blur'
                    }
                ]
            },
            accountNames: [],
            accountInfObj: {}
        }
    },
    created () {
    },
    methods: {
        changeLoading () {
            this.loading = false
            this.$nextTick(() => {
                this.loading = true
            })
        },
        async open (list = []) {
            const data = []
            const idObj = {}
            // 去重
            for (const item of list) {
                if (!idObj[item.id]) {
                    data.push(item)
                    idObj[item.id] = item.id
                }
            }
            this.modal = true
            this.contentLoading = true
            this.msgConfigs = data
            if (data.length === 1) { // 单个
                const defaultData = await this.getMsgContact(data[0])
                this.formData.insert = defaultData.map(({ id, name, phone, email, userSid, description, emailValidate, phoneValidate, defaultContact }) => {
                    return {
                        id,
                        name,
                        oldPhone: phone,
                        phone,
                        oldEmail: email,
                        email,
                        userSid,
                        description,
                        emailValidate,
                        phoneValidate,
                        defaultContact,
                        countDown: JSON.parse(this.countDownJSON)
                    }
                })
            }

            const accountData = await this.getAllAccount() || []
            const accountInfObj = {}
            this.accountNames = accountData.map(({ account, realName, email, mobile, userSid }) => {
                const user = `${realName || '--'}(${account})`
                accountInfObj[user] = { email, phone: mobile, userSid }
                return user
            })
            this.accountInfObj = accountInfObj

            if (!this.formData.insert.length) { // 批量
                this.add()
            }

            this.contentLoading = false
        },
        getMsgContact (data = {}) {
            return this.axios.get(this.urlFormat(API.MSG_MSGCONTACT, true), { params: { configId: data.id } })
        },
        getAllAccount () {
            return this.axios.get(this.urlFormat(API.GET_ACCESS_SUBUSER, false), { params: { includeParent: true, statusNotIn: '0' } })
        },
        // 删除
        deletee (i) {
            if (this.formData.insert.length === 1) {
                this.$Message.error(this.$t('至少保留一个消息接收人!'))
                return
            }
            this.formData.insert.splice(i, 1)
        },
        // 添加
        add () {
            this.formData.insert.push(JSON.parse(JSON.stringify(this.formData.template)))
        },
        validateContactInformation (type, i) {
            const currentCount = this.formData.insert[i].countDown[type]
            if (!currentCount) return
            currentCount.showCount = true
            currentCount.time = setInterval(() => {
                if (currentCount.count <= 1) {
                    currentCount.count = 60
                    currentCount.showCount = false
                    clearInterval(currentCount.time)
                } else {
                    currentCount.count--
                }
            }, 1000)
            const { id } = this.formData.insert[i]
            const typeParam = { // 主要email的时候传参不统一
                phone: 'sms',
                email: 'mail',
                msg: 'msg'
            }[type]
            this.axios.post(this.urlFormat(API.MSG_SENDCONTACT, true), { type: typeParam, id }).then(res => { })
        },
        accountChange (val, i) {
            if (this.accountInfObj[val]) {
                const { email, phone, userSid } = this.accountInfObj[val]
                this.formData.insert[i].email = email
                this.formData.insert[i].oldEmail = email
                this.formData.insert[i].phone = phone
                this.formData.insert[i].oldPhone = phone
                this.formData.insert[i].userSid = userSid
                this.formData.insert[i].emailValidate = 1
                this.formData.insert[i].phoneValidate = 1
            }
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.changeLoading()
                    return
                }
                const params = {
                    configIds: this.msgConfigs.map(item => item.id),
                    insert: this.formData.insert.map(({ id, name, phone, oldPhone, email, userSid, oldEmail, emailValidate, phoneValidate, description, defaultContact }) => {
                        return {
                            id,
                            name,
                            phone,
                            email,
                            userSid,
                            emailValidate: Number(oldEmail === email && emailValidate),
                            phoneValidate: Number(oldPhone === phone && phoneValidate),
                            defaultContact,
                            description
                        }
                    })
                }
                this.axios.put(this.urlFormat(API.MSG_MSGCONTACT, true), params).then(res => {
                    if (res.status) {
                        this.modal = false
                        this.$emit('refresh')
                    } else {
                        this.changeLoading()
                    }
                }).catch(() => {
                    this.changeLoading()
                })
            })
        }
    },
    watch: {
        modal (val) {
            if (!val) {
                this.$refs.form.resetFields()
                this.formData.insert = []
                this.msgConfigs = []
                this.accountNames = []
                this.accountInfObj = {}
            }
        }
    }
}
</script>

<style lang="less" scoped>
.tips {
    min-height: 40px;
    width: 100%;
    line-height: 23px;
    background-color: rgba(252, 248, 239, 1);
    color: #515a6e;
    font-size: 12px;
    padding: 7px 15px;
    border: 1px solid rgba(249, 192, 109, 1);
    i {
        margin-right: 8px;
        color: rgba(249, 192, 109, 1);
        vertical-align: middle;
        font-size: 14px;
        display: inline-block;
    }
    .tips-content {
        width: calc(~'100% - 22px');
        display: inline-block;
    }
}
.custom-table-panel {
    // border: 1px solid #e9e9e9;
    max-width: 1000px;
    width: 100%;
    min-width: 500px;
    margin-top: 15px;
    tr {
        th.require {
            &::after {
                content: '*';
                display: inline-block;
                margin-left: 4px;
                line-height: 1;
                font-family: SimSun;
                font-size: 12px;
                color: #ed4014;
            }
        }
    }
    th,
    td {
        padding: 4px 8px;
        height: 42px;
        .td-txt {
            display: block;
            margin-bottom: 8px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        a.a-disabled {
            color: #c5c8ce;
            cursor: not-allowed;
        }
    }
    th {
        background-color: #f0f2f3;
        text-align: left;
        border-right: 1px solid #e9e9e9;
        white-space: nowrap;
        font-weight: 500;
        font-size: 14px;
    }
    .td-panel {
        display: flex;
        align-items: center;
        a {
            color: #3498dc;
        }
    }
    // tbody {
    //     tr {
    //         td:first-child {
    //             padding-left: 0px;
    //         }
    //     }
    // }
    // .td-panel {
    //     display: flex;
    //     white-space: nowrap;
    //     align-items: center;
    //     & > * {
    //         margin: 0 2px;
    //     }
    // }
}
</style>
<style lang="less">
.custom-table-panel {
    .ivu-select {
        // width: 120px;
        flex-shrink: 0;
    }
    .select-special {
        .ivu-select-item {
            height: auto;
            line-height: normal;
        }
    }
    .ivu-input {
        // width: 120px;
    }
    .ivu-select-single {
    }
    .ivu-select-selection {
        height: 28px;
        input {
            height: 26px;
            line-height: 26px;
        }
    }
    .ivu-select-selected-value,
    .ivu-select-item {
        height: 26px;
        line-height: 26px;
    }
    .ivu-select-item {
        padding: 5px 16px;
    }
    .ivu-input {
        height: 28px;
    }
    .ivu-btn-ghost,
    .ivu-btn-ghost:hover {
        color: #1f68b3;
    }
    .ivu-form-item {
        margin-bottom: 8px;
    }
    .ivu-form-item-error-tip {
        padding-top: 2px;
        white-space: nowrap;
    }
}
</style>
